import { render, staticRenderFns } from "./ReportIssueUpdate.vue?vue&type=template&id=31f68ff6&scoped=true"
import script from "./ReportIssueUpdate.vue?vue&type=script&lang=js"
export * from "./ReportIssueUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f68ff6",
  null
  
)

export default component.exports